/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Box, Link } from "@mui/material";
import IconLinkProps from "./IconLinkProps";

export default function IconLink({ href, children, className, icon, sx, title, ...rest }: IconLinkProps) {
    return (
        <Link
            sx={[
                {
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.5,
                    color: "primary.main"
                },
                ...(!sx ? [] : Array.isArray(sx) ? sx : [sx])
            ]}
            className={className}
            href={href}
            title={title}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            {...rest}
        >
            {children}
            {icon && (
                <Box
                    component="span"
                    sx={{
                        height: "100%",
                        display: "inline-grid",
                        placeItems: "center",
                        "& > *": { fontSize: "inherit" }
                    }}
                >
                    {icon}
                </Box>
            )}
        </Link>
    );
}